import { initKeycloak } from "@utils/keycloak";
import App from "@pages/App.svelte";

export default initKeycloak().then((res) => {
  const app = new App({
    target: document.body,
  });
  return app;
});
